import { render, staticRenderFns } from "./StatisticsPanel.vue?vue&type=template&id=35040c4b&scoped=true&"
import script from "./StatisticsPanel.vue?vue&type=script&lang=js&"
export * from "./StatisticsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsPanel.vue?vue&type=style&index=0&id=35040c4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35040c4b",
  null
  
)

export default component.exports